import { supportedLangs, defaultLang, type Lang } from "@/lib/articles";

export function isSupportedLang(lang: string | undefined): lang is Lang {
  return !!lang && (supportedLangs as readonly string[]).includes(lang);
}

export function resolveLang(lang: string | undefined): Lang {
  return isSupportedLang(lang) ? lang : defaultLang;
}